// Styles
import styles from './ContentSession.module.css';

/**
 * @function ContentSession
 * Describe the component's function
 *
 * @example
 * return (
 *   <ContentSession
 *     index={0}
 *     title=""
 *     room=""
 *     frequency=""
 *     days=""
 *     time=""
 *     games=""
 *     cards=""
 *     daubing=""
 *     fee=""
 *     prizes=""
 *     restrictions=""
 *   />
 * )
 */
function ContentSession({
    index = 0,
    title = '',
    room = '',
    frequency = '',
    days = '',
    time = '',
    games = '',
    cards = '',
    daubing = '',
    fee = '',
    prizes = '',
    restrictions = '',
}: ContentSessionProps): JSX.Element {
    return (
        <article className={styles.container}>
            <header className={styles.header}>
                <h4 className={styles.title}>
                    {index} - <b>{title}</b> session
                </h4>
            </header>
            <table className={styles.table}>
                <tr>
                    <td>Room</td>
                    <td>{room}</td>
                </tr>
                <tr>
                    <td>Frequency</td>
                    <td>{frequency}</td>
                </tr>
                <tr>
                    <td>Days</td>
                    <td>{days}</td>
                </tr>
                <tr>
                    <td>Time</td>
                    <td>{time}</td>
                </tr>
                <tr>
                    <td>No. of games</td>
                    <td>{games}</td>
                </tr>
                <tr>
                    <td>No. of cards</td>
                    <td>{cards}</td>
                </tr>
                <tr>
                    <td>Daub type</td>
                    <td>{daubing}</td>
                </tr>
                <tr>
                    <td>Entry fee</td>
                    <td>{fee}</td>
                </tr>
                <tr>
                    <td>Prizes</td>
                    <td>{prizes}</td>
                </tr>
                <tr>
                    <td>Restrictions</td>
                    <td>{restrictions}</td>
                </tr>
            </table>
        </article>
    );
}

/**
 * @interface ContentSessionProps
 * Describes the properties required for the ContentSession component
 * @property {number} index
 * @property {string} title
 * @property {string} room
 * @property {string} frequency
 * @property {string} days
 * @property {string} time
 * @property {string} games
 * @property {string} cards
 * @property {string} daubing
 * @property {string} fee
 * @property {string} prizes
 * @property {string} restrictions
 */
export interface ContentSessionProps {
    index: number;
    title: string;
    room: string;
    frequency: string;
    days: string;
    time: string;
    games: string;
    cards: string;
    daubing: string;
    fee: string;
    prizes: string;
    restrictions: string;
}

// Exports
export default ContentSession;
